import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LogOut, Settings, ArrowRight } from 'lucide-react';
import { SettingsMenu } from './SettingsMenu';
interface LandingScreenProps {
  onBeginTour: () => void;
  onExit: () => void;
}
export function LandingScreen({
  onBeginTour,
  onExit
}: LandingScreenProps) {
  const [showSettings, setShowSettings] = useState(false);
  return <div className="relative w-full h-screen overflow-hidden bg-slate-900" data-id="element-335">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-336">
        <img src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1920&q=80" alt="Interior background" className="w-full h-full object-cover opacity-30 blur-sm" data-id="element-337" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/80 to-slate-900/60" data-id="element-338" />
      </div>

      {/* Settings Icon - Higher z-index */}
      <div className="absolute top-6 right-6 z-50" data-id="element-339">
        <button onClick={() => setShowSettings(!showSettings)} className="p-3 rounded-full bg-slate-800/50 backdrop-blur-sm border border-white/10 hover:bg-slate-700/50 transition-colors" data-id="element-340">
          <Settings className="w-6 h-6 text-white" data-id="element-341" />
        </button>
      </div>

      {/* Settings Menu */}
      <SettingsMenu isOpen={showSettings} onClose={() => setShowSettings(false)} data-id="element-342" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full" data-id="element-343">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-344">
          {/* Logo */}
          <div className="mb-12" data-id="element-345">
            <motion.img initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6
          }} src="https://cdn.magicpatterns.com/uploads/pf6RkFzoyX8RpYXPcVUgLU/landmark-homes.jpg" alt="Landmark Homes" className="h-40 w-auto mx-auto rounded-lg" data-id="element-346" />
          </div>

          {/* Subtitle */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="mb-12" data-id="element-347">
            <h2 className="text-3xl font-light text-white uppercase tracking-widest mb-8" data-id="element-348">
              Virtual Experience
            </h2>

            {/* Begin Tour Button */}
            <motion.button initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5,
            duration: 0.6
          }} onClick={onBeginTour} className="group inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-[#4a6491] to-[#5a7aa8] hover:from-[#5a7aa8] hover:to-[#6a8ab8] text-white font-medium rounded-lg transition-all shadow-lg hover:shadow-xl uppercase tracking-wider text-sm" data-id="element-349">
              <span data-id="element-350">Begin Landmark Homes Tour</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-351" />
            </motion.button>
          </motion.div>

          {/* Exit Button */}
          <motion.button initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8,
          duration: 0.8
        }} onClick={onExit} className="flex items-center gap-2 text-white/50 hover:text-white transition-colors mx-auto" data-id="element-352">
            <LogOut className="w-5 h-5" data-id="element-353" />
            <span className="text-sm" data-id="element-354">Exit</span>
          </motion.button>
        </motion.div>
      </div>
    </div>;
}